import React from 'react';
import {
  //Image,
  Box,
  //Text
} from '@chakra-ui/react';


//import HeroWithRightMedia from '../../components/sections/herowithrightmedia';


//import EVPSorel from '../../components/ui/ourcompany/leadership/MARK_NENOW_SOREL_BRAND_PRESIDENT_51169_COLORED-copy.jpeg'
// export default function SorelTabPanel() {
//   return (
//     <Box>
//       <HeroWithRightMedia
//         title={
//           <Box>
//             <Text fontWeight={'bold'} mt="10px">
//               MARK NENOW
//             </Text>
//             <Text fontWeight={'bold'} fontSize="md" mb="8">
//               PRESIDENT, SOREL BRAND
//             </Text>
//             <Text fontSize="xs" mb="4">
//               Mark J. Nenow joined Columbia in May 2007 as Vice President of
//               Global Footwear Merchandising and was named President of the Sorel
//               Brand in March 2015. From 2006 to 2007, Mr. Nenow served as Vice
//               President of Global Footwear Merchandising at Brooks Sports. From
//               1995 to 2006, Mr. Nenow worked for NIKE, Inc., where he held
//               various product line management positions in the running and
//               outdoor categories. Prior to his footwear career, Mr. Nenow was a
//               professional track and field athlete and held the American track
//               record for the 10,000 meters from 1986 to 2003.
//             </Text>
//           </Box>
//         }
//         media={
//           <Image width="500" height="441" borderRadius={10} src={EVPSorel} />
//         }
//       />
//     </Box>
//   );
// }

import HeadingWithText from '../../components/sections/headingwithtext'

export default function SorelTabPanel() {
  return (
    <Box>
      <HeadingWithText
        title="COMING SOON..."
      ></HeadingWithText>
    </Box>
  );
}